import { Box, Image, Text, Tooltip } from '@wix/design-system';
import { CreativeOffer } from '@wix/premium-purchase-platform/@sdk';
import { InfoCircleSmall } from '@wix/wix-ui-icons-common';
import React from 'react';
import { StudioPackagePickerModule } from '../../../modules/studio-package-picker.module';

interface ProductCardFeatureRowProps {
  row: CreativeOffer.MarketingFeature;
}

export const ProductCardFeatureRow = ({ row }: ProductCardFeatureRowProps) => {
  const { t, Trans } = StudioPackagePickerModule.internals.useTranslations();

  const handleFeatureTooltipHover = () => {
    // TODO: Handle tooltip hover, BI
  };

  if (!row.content?.localized) {
    return null;
  }

  const { translationKey, tooltipKey } = row.content?.localized;
  const iconUrl = row.presentation?.style?.icon?.url;

  const transTags = {
    b: <b />,
  };

  const transParams = { domainName: undefined };

  return (
    <Box direction="horizontal" width="100%" gap="SP1">
      <Text key={row.featureName} size="small">
        <Trans
          i18nKey={translationKey}
          values={transParams}
          components={transTags}
        />
      </Text>
      {tooltipKey && (
        <Tooltip content={t(tooltipKey)} onShow={handleFeatureTooltipHover}>
          <InfoCircleSmall color="var(--wsr-color-D40)" />
        </Tooltip>
      )}
      {iconUrl ? (
        <Box inline position="relative">
          <Image src={iconUrl} width="18px" height="18px" transparent />
        </Box>
      ) : null}
    </Box>
  );
};
